// src/pages/Partners.jsx
import React from 'react';
import { motion } from 'framer-motion';

const Partners = () => {
  const questions = [
    "Are you an AI expert looking to collaborate?",
    "Do you have industry-specific AI tools?",
    "Want to expand your reach with ambivert.ai?",
  ];

  return (
    <div className="bg-gray-50 text-gray-800">
      {/* Animation Section */}
      <section className="h-[50vh] flex items-center justify-center bg-white px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          className="text-center max-w-4xl"
        >
          <h1 className="text-5xl font-bold mb-6 text-gray-900 leading-tight">
            Join ambivert.ai and expand your reach!
          </h1>
          <div className="text-xl text-gray-600">
            {questions.map((question, index) => (
              <motion.p
                key={index}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: index * 1.5 }} // Stagger animation
                className="mb-2"
              >
                {question}
              </motion.p>
            ))}
          </div>
        </motion.div>
      </section>

      {/* Partner Information Section */}
      <section className="py-12 bg-gray-100">
        <div className="max-w-4xl mx-auto bg-white shadow-md rounded-lg p-8 text-center">
          <h2 className="text-4xl font-semibold mb-4 text-gray-900">
            Collaborate with ambivert.ai
          </h2>
          <p className="text-lg text-gray-600 mb-4">
            We are building a robust platform that connects businesses with experienced AI partners. 
            Our goal is to revolutionize how AI solutions are delivered and adopted across industries.
          </p>
          <p className="text-lg text-gray-600 mb-4">
            If you have expertise in delivering AI solutions and tools, we invite you to join our platform.
            Let’s collaborate and make a bigger impact together.
          </p>
          <p className="text-lg text-gray-600 mb-4">
            To express your interest, email us at <a href="mailto:info@ambivert.ai" className="text-blue-500 underline">info@ambivert.ai</a> 
            with details about:
          </p>
          <ul className="text-left text-lg text-gray-600 list-disc list-inside">
            <li>Your industry expertise</li>
            <li>AI tools and frameworks you specialize in</li>
            <li>Details of your past AI implementation experience</li>
          </ul>
        </div>
      </section>
    </div>
  );
};

export default Partners;